// useMetaPageView.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function useMetaPageView() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);
}
